import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CategorylistComponent } from './components/categorylist/categorylist.component';
import { TemplateComponent } from './components/template/template.component';
import { PhotoitemComponent } from './components/photoitem/photoitem.component';
import {FormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from './components/_modal';
import { CreateSurvyComponent } from './components/create-survy/create-survy.component';
import { ThemeModule, redTheme, blueTheme, whiteTheme, statefarmTheme, westfieldTheme } from './themes';

@NgModule({
  declarations: [
    AppComponent,
    CategorylistComponent,
    TemplateComponent,
    PhotoitemComponent,
    CreateSurvyComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    ModalModule,
    ThemeModule.forRoot({
      themes: [redTheme, blueTheme, whiteTheme, statefarmTheme, westfieldTheme],
      active: 'blue'
    })
  ],
  providers: [{provide: Window, useValue: window}],
  bootstrap: [AppComponent]
})
export class AppModule { }
